import type {Permission} from '@hconnect/apiclient'

export const hasChecklistsPermission = (permissions: Permission[]): boolean =>
  permissions.some(
    (p) => p.permissionType === 'VIEW_CHECKLISTS' || p.permissionType === 'CHANGE_CHECKLISTS'
  )

export const hasViewReliabilityEngineerDashboardPermission = (permissions: Permission[]): boolean =>
  permissions.some((p) => p.permissionType === 'VIEW_RELIABILITY_ENGINEER_DASHBOARD')

export const hasViewProcessEngineerDashboardPermission = (permissions: Permission[]): boolean =>
  permissions.some((p) => p.permissionType === 'VIEW_PROCESS_ENGINEER_DASHBOARD')

export const hasViewOptimizationSpecialistDashboardPermission = (
  permissions: Permission[]
): boolean => permissions.some((p) => p.permissionType === 'VIEW_OPTIMIZATION_SPECIALIST_DASHBOARD')

export const hasRcfaCompliancePagePermission = (permissions: Permission[]): boolean =>
  permissions.some((p) => p.permissionType === 'CONTRIBUTE_TO_ROOT_CAUSE_FAILURE_ANALYSES')

export const hasPerformanceReviewPermission = (permissions: Permission[]): boolean =>
  permissions.some((p) => p.permissionType === 'VIEW_PERFORMANCE_REVIEW')

export const hasMajorOutageLeadDashboardPermission = (permissions: Permission[]): boolean =>
  permissions.some((p) => p.permissionType === 'VIEW_MAJOR_OUTAGE_LEAD_DASHBOARD')

export const hasSystemsEngineerDashboardPermission = (permissions: Permission[]): boolean =>
  permissions.some((p) => p.permissionType === 'VIEW_SYSTEM_ENGINEER_ENTRY_POINT')

export const hasServiceLevelAgreementTrackingPermission = (permissions: Permission[]): boolean =>
  permissions.some((p) => p.permissionType === 'VIEW_SLA_KPIS')

export const hasJobsToBeDonePermission = (permissions: Permission[]): boolean =>
  permissions.some(
    (p) =>
      p.permissionType === 'VIEW_MAJOR_OUTAGE_LEAD_JTBD' ||
      p.permissionType === 'VIEW_OPTIMIZATION_SPECIALIST_JTBD' ||
      p.permissionType === 'VIEW_PROCESS_ENGINEER_JTBD' ||
      p.permissionType === 'VIEW_QUALITY_ENGINEER_JTBD' ||
      p.permissionType === 'VIEW_REGIONAL_MANAGER_JTBD' ||
      p.permissionType === 'VIEW_RELIABILITY_ENGINEER_JTBD' ||
      p.permissionType === 'VIEW_SYSTEM_ENGINEER_JTBD'
  )

export const hasRiskSurveyPermission = (permissions: Permission[]): boolean =>
  permissions.some((p) => p.permissionType === 'HPRODUCE_ROLE_VIEWER')
